export const Version = {
	Major: 0,
	Minor: 4,
	Patch: 0,
}

export function getVersionString() {
	return `${Version.Major}.${Version.Minor}.${Version.Patch}`;
}

export function getVersionNumber() {
	return Version.Major * 100 + Version.Minor;
}